import { BuilderConfig } from '../../types/Builder';
import BusinessResourceTopStrips, { Props } from './business-resource-top-strips';

export const BusinessResourceTopStripsBuilderConfig = {
    name: 'Resource Top Strips',
    inputs: [
        {
            name: 'assets',
            type: 'list',
            copyOnAdd: false,
            subFields: [
                {
                    name: 'name',
                    type: 'string',
                },
                {
                    name: 'variants',
                    type: 'list',
                    copyOnAdd: false,
                    subFields: [
                        {
                            name: 'variantName',
                            type: 'string',
                        },
                        {
                            name: 'previewUrl',
                            type: 'url',
                        },
                        {
                            name: 'downloadUrl',
                            type: 'url',
                        },
                        {
                            name: 'pagePreviewImage',
                            type: 'file',
                        },
                        {
                            name: 'extension',
                            type: 'string',
                        },
                    ],
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<Props> = {
    component: BusinessResourceTopStrips,
    config: BusinessResourceTopStripsBuilderConfig,
};

export default builderConfig;
